var render = function render(){var _vm=this,_c=_vm._self._c;return _c('campaign-form',{ref:"form",attrs:{"segment":_vm.segment,"purchaser-models":_vm.purchaserModels},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }